import { useRef, useState } from 'react';
import clsx from 'clsx';
import * as R from 'ramda';

import { Popover } from '@atom/components/common/mui';
import TimeEntryStatusIcon from '@atom/components/common/timeEntryStatusIcon/TimeEntryStatusIcon';
import { TimeEntriesConnection, TimeEntryStatus } from '@atom/types/timeEntry';
import {
  convertMillisToExactHours,
  convertMillisToHours,
} from '@atom/utilities/timeUtilities';

import classes from './timeHeaders.module.css';

interface Props {
  timeEntriesConnection: TimeEntriesConnection;
}

const SummaryHeader = ({ timeEntriesConnection }: Props) => {
  const status = timeEntriesConnection?.status || TimeEntryStatus.draft;
  const hasNoTimeEntries = R.isEmpty(timeEntriesConnection?.timeEntries);
  const wageTypeSummaries = R.pathOr([], ['summary'], timeEntriesConnection);
  const popoverAnchor = useRef(null);

  const [openCutoffTypes, setOpenCutoffTypes] = useState<boolean>(false);

  return (
    <div className={classes.summaryRow}>
      <div className={classes.commonCells}>
        <div className={classes.summaryItem}>
          <div className={clsx(classes.summaryItemTitle, classes.status)}>
            Status
          </div>
          {hasNoTimeEntries ? (
            <div className={classes.emptyTitle}>Not Started</div>
          ) : (
            <div className={classes.statusContainer}>
              <TimeEntryStatusIcon status={status} />
              <div className={classes.statusName}>{status}</div>
            </div>
          )}
        </div>
        <div className={classes.summaryItem}>
          <div className={classes.summaryItemTitle}>Total Time</div>
          <div className={classes.summaryItemValue}>
            {convertMillisToExactHours(
              timeEntriesConnection?.totalDuration || 0,
            )}
          </div>
        </div>
        <div className={classes.summaryItem}>
          <div className={classes.summaryItemTitle}>Total Work Templates</div>
          <div className={classes.summaryItemValue}>
            {timeEntriesConnection?.totalWorkTypes || 0}
          </div>
        </div>
        <div className={classes.summaryItem}>
          <div className={classes.summaryItemTitle}>Total Work</div>
          <div className={classes.summaryItemValue}>
            {timeEntriesConnection?.totalWorkOrders || 0}
          </div>
        </div>
      </div>
      <div className={classes.elasticCells}>
        {wageTypeSummaries.map(type => (
          <div className={classes.summaryItem}>
            <div className={classes.summaryItemTitle}>{type.title}</div>
            <div className={classes.summaryItemValue}>
              {convertMillisToHours(type.duration) || 0} Hours
            </div>
          </div>
        ))}
      </div>
      <div className={classes.linkCell}>
        <div className={classes.summaryItem} ref={popoverAnchor}>
          <div className={classes.summaryItemValue}>
            {!R.isEmpty(wageTypeSummaries) && (
              <button onClick={() => setOpenCutoffTypes(true)}>
                View All Wage Types ({wageTypeSummaries.length})
              </button>
            )}
          </div>
        </div>
        <Popover
          open={openCutoffTypes}
          anchorEl={popoverAnchor.current}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          onClose={() => setOpenCutoffTypes(false)}
        >
          <ul className={classes.cutoffTypesList}>
            {wageTypeSummaries.map(type => (
              <li>
                {type.title}:{' '}
                <strong>{convertMillisToHours(type.duration)} Hours</strong>
              </li>
            ))}
          </ul>
        </Popover>
      </div>
    </div>
  );
};

export default SummaryHeader;
